import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { HomeView } from "./HomeView";
import { createUrl, get, post } from "../../network/AxiosInterceptor";
import {
  containsMonth,
  getCurrentAndNextThreeMonths,
} from "../../utils/DateUtils";
import { useTrip } from "../../contextApi/tripContext";
import { set } from "date-fns";

const Home = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const homePageCards = useRef(null);
  const navigate = useNavigate();
  const allTrips = useTrip();

  useEffect(() => {
    if (window.location.pathname !== "/") navigate("/");
  });

  const trips = useRef([]);
  const [tripData, setTripData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [reviewData, setReviewData] = useState([]);

  useEffect(() => {
    const onFiltersUpdated = () => {
      if(tripData.length==0 && selectedCategory=="")return;
      if (selectedCategory === "" || selectedCategory === "All" ) {
        setTripData(allTrips.trips.filter(
          (tr) =>
            selectedMonth === "" ||
            selectedMonth === "All" ||
            containsMonth(tr.tripDates, selectedMonth)
        ));
      } else {
        var tr=[];
        setTripData(() => {
          
          // return (
            tr= allTrips.trips.filter((tr) =>
              tr.tripCategory.includes(selectedCategory.split(' ')[0])
            ).filter(
              (tr) =>
                selectedMonth === "" ||
                selectedMonth === "All" ||
                containsMonth(tr.tripDates, selectedMonth)
            );
            if(tr.length==0){tr=allTrips.trips}
            return tr;
            // allTrips.trips
            //   .filter(
            //     (tr) => tr.tripCategory.includes(selectedCategory)
            //   )
              // .filter(
              //   (tr) =>
              //     selectedMonth === "" ||
              //     selectedMonth === "All" ||
              //     containsMonth(tr.tripDates, selectedMonth)
              // )
              
          // );
        });
      }
    };

    onFiltersUpdated();
  }, [selectedCategory, selectedMonth]);

  const fetchTr = async () => {
    const home = true;
    allTrips.fetchTrips(setTripData, { home });
  };

  useEffect(() => {
    fetchTr();
  }, []);

  const fetchAllTrips = async () => {
    post(createUrl(`/api/trips/listing`), {})
      .then((response) => {
        trips.current = response.data.trips;
        setTripData(response.data.trips.slice(0, 9));
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAllReviews();
  }, []);

  const fetchAllReviews = async () => {
    get(createUrl("/api/reviews/getReviews?reviewStatus=live"))
      .then((response) => {
        setReviewData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const influencerData = [
    {
      img: "https://static.wixstatic.com/media/da937f_85d32a92a3b245aea0099700cfaecfd2~mv2.webp",
      name: "Arushi Chawla",
      instaId: "arushi.chawla",
      followers: "373K Followers",
      influencerImage:
        "https://static.wixstatic.com/media/da937f_19d785bce010442e9bab6a9e6095c617~mv2.png",
    },
    {
      img: "https://static.wixstatic.com/media/da937f_1e57d20db53d4dec9caf2337541cfe64~mv2.webp",
      name: "Ashwin KC",
      instaId: "droneholic_",
      followers: "318K Followers",
      influencerImage:
        "https://static.wixstatic.com/media/da937f_5bd2d6698a644bc7825c746521bf1312~mv2.webp",
    },
    {
      img: "https://static.wixstatic.com/media/da937f_f2c23e68c96f4adbb3f5f1b3e040084d~mv2.webp",
      name: "Prabir Das",
      instaId: "iam_prabir_das",
      followers: "187K Followers",
      influencerImage:
        "https://static.wixstatic.com/media/da937f_37a315bd4b91450fb20979424d215e18~mv2.png",
    },
    {
      img: "https://static.wixstatic.com/media/da937f_a09c4fab9b974dcd8f7507d080abc7c0~mv2.webp",
      name: "Ankitha Rajendaran",
      instaId: "wayfarer_anki",
      followers: "154K Followers",
      influencerImage:
        "https://static.wixstatic.com/media/da937f_94885a35050e4c85818ac469c03c285c~mv2.png",
    },
    {
      img: "https://static.wixstatic.com/media/da937f_15a04974b6da47de903d69b137fbea74~mv2.webp",
      name: "Munachiya",
      instaId: "munachiya",
      followers: "131K Followers",
      influencerImage:
        "https://static.wixstatic.com/media/da937f_e52c3f079b8045c286d50cbb921187d9~mv2.png",
    },
    {
      img: "https://static.wixstatic.com/media/da937f_517018b7e2ca4d7cabe33c487555f149~mv2.webp",
      name: "Khushbu",
      instaId: "itsjustttyou",
      followers: "138K Followers",
      influencerImage:
        "https://static.wixstatic.com/media/da937f_c15193d039d2481d8865de76e4c37a56~mv2.png",
    },
  ];

  const tripDataHandler = (tripCategory) => {
    setSelectedCategory(tripCategory);
  };

  const dropdownOptions = [
    { label: "All", value: "All" },
    { label: "Influencer Curated", value: "Influencer Curated" },
    { label: "International Experiences", value: "International Experience" },
    { label: "Weekend Getaways", value: "Weekend Getaway" },
    { label: "Mindful Retreats", value: "Mindful Retreat" },
  ];

  const months = getCurrentAndNextThreeMonths();

  const monthOptionsArr = [
    { label: months[0].formattedMonth, value: months[0].month },
    { label: months[1].formattedMonth, value: months[1].month },
    { label: months[2].formattedMonth, value: months[2].month },
  ];

  const tripMonthHandler = (month) => {
    setSelectedMonth(month);
    homePageCards.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };

  const onViewAllClicked = () => {
    navigate("/exploretrips");
  };

  return (
    <div>
      <HomeView
        tripData={tripData}
        influencerData={influencerData}
        reviewData={reviewData}
        homePageCards={homePageCards}
        tripMonthHandler={tripMonthHandler}
        tripDataHandler={tripDataHandler}
        dropdownOptions={dropdownOptions}
        monthOptionsArr={monthOptionsArr}
        onViewAllClicked={onViewAllClicked}
        selectedCategory={selectedCategory}
      />
    </div>
  );
};

export default Home;
